import {
  useABAC,
  useAccountClient,
  useSnackbarNotification,
  LogoContext,
} from '@jupiterone/jupiter-web-toolkit';
import { useState, useContext } from 'react';

const useAlterCompanyLogo = () => {
  const { enforce } = useABAC();
  const accountClient = useAccountClient();
  const notification = useSnackbarNotification();
  const [loading, setIsLoading] = useState(false);
  const appContext = useContext(LogoContext.LogoContext);
  const { handleSetLogoURI } = appContext;
  const isEnabled = enforce([]);

  const handleSetContextURI = (uri: string) => {
    if (handleSetLogoURI) {
      handleSetLogoURI(uri);
    }
  };

  const changeAccountLogoUrl = async (
    imageUrlValue: string,
    callback?: (x: boolean) => void
  ) => {
    setIsLoading(true);
    if (isEnabled) {
      try {
        await accountClient.updateAccountLogo(imageUrlValue);
        handleSetContextURI(imageUrlValue);
        notification.success(
          'Successfully updated account company logo url',
          3000
        );
        if (callback) {
          callback(false);
        }
      } catch (e) {
        notification.error({
          message: 'Failed to update account logo',
          error: e,
          autoHideDuration: 3000,
        });
        if (callback) {
          callback(true);
        }
      }
    }
    setIsLoading(false);
  };

  return { changeAccountLogoUrl, loading };
};

export default useAlterCompanyLogo;
